<template>
    <lti-drawer
        :active="active"
        title="Edverum - Turnitin Integration"
        @close="reloadPage"
        @restore="loadLaunchData"
        @update:active="$emit('update:active', $event)"
    >
        <div class="is-flex is-flex-direction-column is-height-full">
            <p class="mb-4">Please follow the steps to review and grade the submission.</p>

            <div ref="ltiContainer" class="turnitin-iframe-container is-flex-grow-1" />
        </div>
    </lti-drawer>
</template>

<script>
import LtiDrawer from '@/components/lti/LtiDrawer.vue';

export default {
    components: {
        LtiDrawer,
    },

    props: {
        active: {
            type: Boolean,
            default: false,
        },
        ltiResourceLinkId: {
            type: Number,
            required: true,
        },
        lineItemId: {
            type: [Number, String],
            required: false,
            default: null,
        },
        forUserId: {
            type: [Number, String],
            required: false,
            default: null,
        },
        returnUrl: {
            type: String,
            required: false,
            default: () => window.location.href,
        },
        fromCourse: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    emits: ['close', 'update:active'],

    data() {
        return {
            launchAssignmentUrl: '',
        };
    },

    watch: {
        active(val) {
            if (val) {
                this.loadLaunchData();
            }
        },
    },

    mounted() {
        if (this.active) {
            this.loadLaunchData();
        }
    },

    methods: {
        reloadPage() {
            if (this.fromCourse) {
                this.$emit('close');
            } else {
                window.location.reload();
            }
        },

        async loadLaunchData(payload) {
            if (payload?.relaunch === false) {
                return;
            }

            if (this.ltiResourceLinkId) {
                this.$nextTick(() => {
                    const container = this.$refs.ltiContainer;

                    if (container) {
                        const launchUrl = this.buildLaunchUrl();
                        const existingIframe = container.querySelector('iframe');

                        if (existingIframe?.dataset?.launchUrl === launchUrl) {
                            return;
                        }

                        container.innerHTML = '';
                        const iframe = document.createElement('iframe');
                        iframe.style.width = '100%';
                        iframe.style.height = '100%';
                        iframe.style.border = 'none';
                        iframe.src = launchUrl;
                        iframe.dataset.launchUrl = launchUrl;
                        container.appendChild(iframe);
                    }
                });
            }
        },

        buildLaunchUrl() {
            const baseUrl = import.meta.env.VITE_APP_URL;

            if (!this.forUserId) {
                return `${baseUrl}/lti/links/${this.ltiResourceLinkId}`;
            }

            const params = new URLSearchParams({
                for_user: this.forUserId,
            });

            if (this.returnUrl) {
                params.set('return_url', this.returnUrl);
            }

            if (this.lineItemId) {
                params.set('lineitem', this.lineItemId);
            } else {
                params.set('resource_link_id', this.ltiResourceLinkId);
            }

            return `${baseUrl}/lti/submission-review?${params.toString()}`;
        },
    },
};
</script>
